export const DOC_TYPES = [
  "AADHAAR", "PAN", "PASSPORT", "VOTER_ID", "NATIONAL_ID", "IQAMA",
  "DRIVING_LICENSE", "RATION_CARD", "ABHA_CARD", "INSURANCE_CARD", "OTHER",
];

export const PATIENT_TYPES = [
  "NORMAL", "VIP", "STAFF", "STAFF_DEPENDENT", "CORPORATE",
  "INTERNATIONAL", "NEWBORN", "SENIOR_CITIZEN",
];

export const NATIONALITIES = [
  "Indian", "American", "British", "Canadian", "Australian",
  "Bangladeshi", "Nepali", "Sri Lankan", "Saudi", "Emirati", "Other",
];

export const RELIGIONS = [
  "Hindu", "Muslim", "Christian", "Sikh", "Buddhist", "Jain", "Parsi", "Jewish", "Other",
];

export const PAYERS = [
  "Star Health", "ICICI Lombard", "HDFC Ergo", "Bajaj Allianz",
  "New India Assurance", "MediAssist TPA", "Paramount TPA", "FHPL TPA",
  "Vidal Health TPA", "Other",
];

export const TITLES = ["Mr", "Ms", "Mrs", "Mx", "Dr", "Baby"];
export const GENDERS = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "OTHER", label: "Other" },
];
export const MARITAL_STATUSES = ["SINGLE", "MARRIED", "DIVORCED", "WIDOWED"];
export const BLOOD_GROUPS = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
export const CONTACT_CHANNELS = ["PHONE", "EMAIL", "FAX"];
export const CONTACT_TYPES = ["PRIMARY", "SECONDARY", "HOME", "WORK"];
export const ADDRESS_TYPES = ["PERMANENT", "CURRENT"];
export const ADMISSION_TYPES = ["GENERAL", "EMERGENCY", "DAY_CARE"];
export const FINANCIAL_CLASSES = [
  ["CASH", "CASH"], ["CORP", "CORP"], ["TPA", "TPA"], ["INSURANCE", "INSURANCE"],
  ["STAFF", "STAFF"], ["GOVT_SCHEME", "GOVERNMENT SCHEME"],
];
export const DEPARTMENTS = [
  "Cardiology", "General Medicine", "Orthopedics", "Neurology", "Pediatrics",
];
export const SITES = ["HTMATE Main", "HTMATE North", "HTMATE South", "HTMATE East"];
export const FACILITIES = [
  "HTMATE Hospital — Unit 1", "HTMATE Hospital — Unit 2",
  "HTMATE Clinic", "HTMATE Diagnostics",
];
export const LOCATIONS = ["Block A", "Block B", "Block C", "OPD Wing", "Emergency Wing"];
export const FAMILY_RELATIONS = [
  "Spouse", "Father", "Mother", "Son", "Daughter", "Brother", "Sister", "Guardian", "Other",
];
export const GUARANTOR_RELATIONS = [
  "Self", ...FAMILY_RELATIONS,
];
export const SEARCH_BY_OPTIONS = [
  ["abhaId", "ABHA Address"],
  ["abhaNo", "ABHA No"],
  ["phoneNo", "Phone No"],
  ["demographics", "Demographics"],
  ["PatID", "PAT ID"],
  ["uhid", "UHID"],
];
export const SOURCE_TYPES = [
  { value: "HOSPITAL", label: "Another Hospital" },
  { value: "MARKETING_PERSON", label: "Marketing Person" },
  { value: "EXTERNAL_DOCTOR", label: "External Doctor" },
  { value: "EMPLOYEE", label: "Employee" },
];

export const SEED_REF_DOCTORS = [
  { id: "RD-001", name: "Dr. Anand Rao", phone: "9876543210" },
  { id: "RD-002", name: "Dr. Priya Menon", phone: "9876501234" },
  { id: "RD-003", name: "Dr. Vikram Shah", phone: "9876512345" },
];

export const DEFAULT_SECTIONS = [
  "patient_personal_detail", "addresses", "admission", "bed",
];

export const EMPTY_PATIENT = {
  site: "HTMATE Main",
  facility: "HTMATE Hospital — Unit 1",
  location: "Block A",
  abhaAddress: "",
  abhaNumber: "",
  title: "Mr",
  name: "",
  gender: "",
  dob: "",
  ageOnly: "",
  maritalStatus: "",
  bloodGroup: "",
  nationality: "Indian",
  religion: "",
  occupation: "",
  identityMarks: "",
  primaryMobile: "",
  secondaryMobile: "",
  patientType: "NORMAL",
  familyPhysicianName: "",
  familyPhysicianPhone: "",
  photoUrl: "",
  uhid: "",
  patient_id: "",
  admission_id: null,
  contacts: [{ channel: "PHONE", type: "PRIMARY", value: "" }],
  addresses: [{
    type: "PERMANENT", line1: "", city: "", district: "", state: "", country: "India", pincode: "",
  }],
  emergencyContacts: [{ name: "", relation: "", phone: "", address: "" }],
  guarantors: [],
  documents: [],
  family: [],
  source: {
    sourceType: "", hospitalName: "", marketingName: "", employeeName: "", referralDoctorId: "",
  },
  consentFileName: "",
  encounter: {
    admissionType: "GENERAL",
    financialClass: "CASH",
    payer: "",
    employeeId: "",
    insurancePolicyNo: "",
    policyExpiry: "",
    // TPA for insurance / government-scheme admissions (optional) — code + display name.
    tpaCode: "",
    tpaName: "",
    provisionalDiagnosis: "",
    department: "",
    departmentId: "",
    admittingDoctorId: "",
    admittingDoctorName: "",
    attendingDoctorRows: [],
    wardNo: "",
    bedTypeName: "",
    roomNo: "",
    bedId: "",
    newBedStatus: "reserved",
  },
};
